import { sendTracking } from '@helpers/tracking';

const faiTracking = {
    universe: 'Boutique_fai',
    marketLine: 'Fai',
};

export function sendHomePageTracking(defaultTab = window.location.hash?.replace('#', '')) {
    sendTracking(false, {
        page: 'Home_fai',
        category: 'Eligibilite',
        pageCategory: 'Liste_produits_fai',
        eCommerceStep: 'Liste_produits',
        variant: {
            onglet: defaultTab ?? '',
            etape_eligibilite: 'Eligibilite_accueil',
        },
        ...faiTracking,
    });
}
